import { useState } from 'react';
import { faqList } from '@/mocks/ranking';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.4fr] lg:gap-12">
          <div className="lg:sticky lg:top-24 lg:self-start">
            <SectionHeading
              eyebrow="吃瓜前先搞懂规则"
              title="吃瓜问答"
              desc="关于投票规则、榜单更新与内容来源的常见疑问，都帮你一次性说清楚。"
            />
            <div className="hidden rounded-3xl border border-background-200 bg-background-100/70 p-5 lg:block">
              <h4 className="flex items-center gap-2 font-display text-lg text-foreground-900">
                <i className="ri-question-answer-line text-xl leading-none text-secondary-600" />
                还有疑问？
              </h4>
              <p className="mt-2 text-sm text-foreground-600">
                没有找到想要的答案，欢迎到页面底部联系我们，我们会尽快回复每一位吃瓜群众。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {faqList.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={i} className={`overflow-hidden rounded-2xl border transition-colors ${open ? 'border-secondary-300 bg-secondary-100/50' : 'border-background-200 bg-background-100/60'}`}>
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    className="flex w-full items-center gap-3 px-5 py-4 text-left"
                    aria-expanded={open}
                  >
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${open ? 'bg-secondary-500 text-background-50' : 'bg-background-200 text-foreground-600'}`}>
                      Q{i + 1}
                    </span>
                    <span className="flex-1 text-base font-semibold text-foreground-900">{f.q}</span>
                    <i className={`${open ? 'ri-subtract-line' : 'ri-add-line'} text-lg leading-none text-foreground-500 transition-transform`} />
                  </button>
                  {open && (
                    <div className="flex gap-3 px-5 pb-5 pl-16">
                      <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}